import React from 'react';

/**
 * ErrorBoundary — capture toute erreur d'affichage React et présente un écran de
 * récupération au lieu d'un écran blanc. L'utilisateur reste connecté et peut
 * recharger ou revenir à l'accueil sans perdre sa session.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Erreur capturée :', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center">
          <div className="w-14 h-14 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto mb-4">
            <i className="bi bi-exclamation-triangle text-amber-500 text-2xl" />
          </div>
          <h2 className="text-lg font-bold text-slate-800">Une erreur est survenue sur cette page</h2>
          <p className="text-sm text-slate-500 mt-2">
            Pas d'inquiétude, vous êtes toujours connecté et vos données sont intactes.
            Réessayez ou revenez à l'accueil.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6">
            <button
              onClick={this.handleReset}
              className="px-4 py-2 text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition"
              data-testid="error-boundary-retry"
            >
              <i className="bi bi-arrow-clockwise mr-1" /> Réessayer
            </button>
            <button
              onClick={() => { window.location.href = '/'; }}
              className="px-4 py-2 text-sm font-semibold bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 rounded-lg transition"
              data-testid="error-boundary-home"
            >
              Accueil
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
